const config = {
    // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
    // like '/berry-material-react/react/default'
    basename: '',
    defaultPath: '/dashboard/default',
    fontFamily: `'Poppins', sans-serif`,
    borderRadius: 12,
    theme: 'dark',
    url: 'https://swapi.dev/api/',
    debounceTime: 1000
};

export default config;
